import {Component, EventEmitter, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Client, ClientLocation, ClientVendorCreds} from '../../clients-module/models/clientLocation';
import {AuthService} from '../../services/auth.service';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import {ClientService} from '../../clients-module/services/client.service';
import {ToastrService} from 'ngx-toastr';
import {Address} from '../../models/Address';
import {PhonePipe} from '../../pipes/phone.pipe';
import {PropertyService} from '../services/property.service';
import {NgForm} from '@angular/forms';
import { debounce } from 'rxjs/operators';
import { timer } from 'rxjs';
import * as _ from 'lodash';

@Component({
  selector: 'app-properties-add',
  templateUrl: './properties-add.component.html',
  styleUrls: ['./properties-add.component.css']
})
export class PropertiesAddComponent implements OnInit, OnDestroy {

  @ViewChild('form', {}) ngForm: NgForm;
  public model: ClientLocation = new ClientLocation();
  public propertyId: number;
  public clientId: number;
  public currentClient: Client;
  public saving : boolean = false;
  public showErrors: boolean = false;

  constructor(public phone: PhonePipe,
              public auth: AuthService,
              public location: Router,
              public activatedRoute: ActivatedRoute,
              public clients: ClientService,
              public properties: PropertyService,
              public toastr: ToastrService) {

  }

  public ngOnInit(): void {
    this.model.creds = new ClientVendorCreds();

    this.activatedRoute.paramMap.subscribe((p: ParamMap) => {
      this.clientId = parseInt(p.get('client'));

      if (p.get('client')) {
        // this.propertyId = parseInt(p.get('prop'));
        this.clientId = parseInt(p.get('client'));
        this.setupModel();
        this.properties.FetchMarketSegments();
      }
    });

  }

  public ngOnDestroy(): void {
    this.ngForm.reset();
  }

  public setupModel(): void {
    if (this.clientId) {
      this.model.clientId = this.clientId;
    }

    // We need to fetch the client here so we have access to some of its properties
    this.clients.GetClientById(this.clientId).subscribe((res: Client) => {
        this.currentClient = res;
        this.model.isActive = true;
        this.model.manualProcessing = true;
        this.model.creds.clientLocationId = this.model.id;

        const ad = new Address();
        ad.physical = true;
        ad.billing = true;
        ad.id = 0;
        ad.isDefault = true;

        this.model.addresses.push(ad);

      },
      err => {
        this.toastr.error('Error fetching client!', '', {closeButton: true, disableTimeOut: true});
      });
  }

  public saveLocation(): void {
    if(this.model.addresses.length == 0)
    {
      this.toastr.error('Please complete physical address before saving.');
      this.showErrors = true;
      return;
    }
    if(this.model.addresses.find(addy => {return !addy.isValid}))
    {
      this.toastr.error('One or more addresses invalid. Please correct any issues before saving.');
      this.showErrors = true;
      return;
    }

    if(this.ngForm.valid) {
      this.saving = true;
      this.properties.SaveProperty(this.model).subscribe(
        (scc: ClientLocation) => {
          this.toastr.success(`Successfully saved client location ${scc.locationName}.`, 'Property Saved Successfully');
          this.propertyId = scc.id;
          this.showErrors = false;
          this.clientId = scc.clientId;
          this.cancel(); // I know its misleading.. just need to nav back over to the client review page.
        },
        (err: any) => {
          this.toastr.error(`Error saving client location.`, 'Property Save Failed', {disableTimeOut: true, closeButton: true});
          this.saving = false;
        },
      );
    }
    else {
      this.showErrors = true;
    }
  }

  public cancel(): void {
    this.location.navigateByUrl(`/properties/stats/${this.propertyId}/${this.clientId}`);
  }

  public loadDefaultClientValues(): void {

    // this.model.manualProcessing = this.currentClient.manualProcessing; RIQ-2154: disable this, we want the default setting to ALWAYS be TRUE, regardless of what is at the client level.
    this.model.autoSendAALOverride = this.currentClient.autoSendAAL;
    this.model.mainContactName = this.currentClient.mainContactName;
    this.model.mainPhone = this.currentClient.mainPhone;
    this.model.fax = this.currentClient.fax;
    this.model.mainContactEmail = this.currentClient.email;
    this.model.ownerName = this.currentClient.ownerName;
    this.model.ownerCompany = this.currentClient.ownerCompany;
    this.model.ownerPhone = this.currentClient.ownerPhone;
    this.model.ownerEmail = this.currentClient.ownerEmail;
    this.model.affiliateName = this.currentClient.affiliateName;
    this.model.rentalUnitCount = this.currentClient.rentalUnitCount;
    this.model.addresses = [] = this.properties.copyAddresses(this.currentClient.addresses);
  }


  
}
